/**
 * Elimina caracteres especiales del nombre de un archivo, dejando solo letras sin acentos, números, guiones y puntos.
 * @param fileName - Nombre del archivo a limpiar.
 * @returns El nombre del archivo limpio.
 */
export function sanitizeFileName(fileName: string): string {
  // Expresión regular para eliminar caracteres especiales, incluyendo letras con acentos y otros signos diacríticos
  return fileName
      .normalize('NFD') // Normaliza los caracteres, separando letras de sus signos diacríticos
      .replace(/[\u0300-\u036f]/g, '') // Elimina los signos diacríticos
      .replace(/[^a-zA-Z0-9.\-_]/g, ''); // Permite solo letras, números, guiones, y puntos
}
